import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 49614 38029"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970274128720">
        <path
          d="M26130 38029c-547 0-1087-240-1453-701-636-803-503-1968 300-2604l19802-15710L24977 3305c-802-636-936-1801-300-2603 636-803 1801-936 2603-301l21633 17162c442 350 701 886 701 1451 0 566-259 1101-701 1452L27280 37628c-340 270-746 401-1150 401z"
          className="fil0"
        />
        <path
          d="M13993 38029c-547 0-1088-240-1453-701-637-803-503-1968 300-2604l19801-15710L12840 3305c-802-636-936-1801-300-2603 636-803 1802-936 2603-301l21632 17162c443 350 702 886 702 1451 0 566-259 1101-702 1452L15143 37628c-341 270-748 401-1150 401z"
          className="fil0"
        />
        <path
          d="M1855 38029c-548 0-1087-240-1454-701-635-803-502-1968 301-2604l19802-15710L702 3305c-802-636-936-1801-301-2603 637-803 1802-936 2604-301l21632 17162c443 350 702 886 702 1451 0 566-259 1101-702 1452L3005 37628c-340 270-746 401-1150 401z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
